module.exports = __webpack_public_path__ + "assets/images/scene-4_142f358a7833d5e55fa399b01a0068ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/croma-abeldo-dialogs/scene-4.png
// module id = 247
// module chunks = 0